import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox,
  FDContentContainer, FDHeadlineText,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import DeleteButton from './DeleteButton';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = React.useState(false);

  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  async function handleSubmit() {
    try {
      setLoading(true);
      await resource.submit();
      clearModalCollection();
      refreshPageContentCollection();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  }

  return (
    <FDContentContainer maxWidth="md">
      <FDBox padding={2}>
        <FDStack direction="column" spacing={3}>
          {resource.attr('outcomeTitle') && <FDHeadlineText value={resource.attr('outcomeTitle')} />}
          <MetaLayoutVertical resource={resource} />

          {resource.meta().canDelete() ? (
            <DeleteButton
              onDelete={handleDelete}
              onDeleteSuccess={onDeleteSuccess}
              dialogProps={{
                title: 'Are you sure?',
                message: 'Removing this item will delete all of its information. This cannot be undone.',
                confirmLabel: 'Remove',
              }}
            />
          ) : null}
          <FDStack flexGrow={1} />
          <FDPrimaryActionButton
            size="md"
            isFullWidth
            label="Submit"
            onClick={handleSubmit}
            loading={loading}
          />
        </FDStack>
      </FDBox>
    </FDContentContainer>
  );
};

export default Layout;
